import { createSlice } from '@reduxjs/toolkit';
import { getLocalKey } from '../../utils/commonfunction';

// localStorage se auth load karo - refresh pe bhi data rahe
const loadAuthFromStorage = () => {
    try {
        const userData = getLocalKey("admin_user");
        if (userData) {
            const parsed = JSON.parse(userData);
            return {
                user: parsed,
                token: parsed?.token || null,
                role: parsed?.role || null,
                permissionRole: parsed?.permission_role || null,
                permissions: parsed?.permission_role?.permissions || [],
                routes: parsed?.permission_role?.permissions?.map(p => p.route).filter(Boolean) || [],
                isAuthenticated: !!parsed?.token,
            };
        }
    } catch (e) {}
    return {
        user: null,
        token: null,
        role: null,
        permissions: [],
        routes: [],
        permissionRole: null,
        isAuthenticated: false,
    };
};

const initialState = loadAuthFromStorage();

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuth: (state, action) => {
            const userData = action.payload;
            state.user = userData;
            state.token = userData?.token || null;
            state.role = userData?.role || null;
            state.permissionRole = userData?.permission_role || null;
            state.permissions = userData?.permission_role?.permissions || [];
            state.routes = userData?.permission_role?.permissions?.map(p => p.route).filter(Boolean) || [];
            state.isAuthenticated = !!userData?.token;
        },
        updateUser: (state, action) => {
            if (state.user) {
                state.user = { ...state.user, ...action.payload };
            }
        },
        updatePermissions: (state, action) => {
            state.permissions = action.payload || [];
            if (state.permissionRole) {
                state.permissionRole = {
                    ...state.permissionRole,
                    permissions: action.payload || []
                };
            }
        },
        clearAuth: (state) => {
            state.user = null;
            state.token = null;
            state.role = null;
            state.permissions = [];
            state.routes = [];
            state.permissionRole = null;
            state.isAuthenticated = false;
        },
    }
});

export const { setAuth, updateUser, updatePermissions, clearAuth } = authSlice.actions;

export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectRole = (state) => state.auth.role;
export const selectPermissions = (state) => state.auth.permissions;
export const selectPermissionRole = (state) => state.auth.permissionRole;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectRoutes = (state) => state.auth.routes;

export default authSlice.reducer;